import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FourDotFiveDateFormatPipe } from 'src/app/core/pipes/four-dot-five-date-format.pipe';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { CompanyService } from 'src/app/core/services/company.service';
import { DateTimeUtilityService } from 'src/app/core/services/date-time-utility.service';
import { JobMatchService } from 'src/app/core/services/job-match.service';
import moment from 'moment';
import { NgForm } from '@angular/forms';
import { AngularModalService } from 'src/app/core/services/modal.service';

@Component({
  selector: 'app-fill-or-join-candidate',
  templateUrl: './fill-or-join-candidate.component.html',
  styleUrls: ['./fill-or-join-candidate.component.css']
})
export class FillOrJoinCandidateComponent implements OnInit {

  @ViewChild('fillOrjoinCandidateForm', {static: true}) fillOrjoinCandidateForm:NgForm;
  @Input() job: any;
  @Input() candidates: any;
  @Input() candidatesInLastStep: any;
  @Input() isSharedRequisition: any;
  @Input() sourceScreen: any;
  @Input() formalizeActivityPayload: any;
  @Output() saveCallback = new EventEmitter<any>();
  @Output() cancelCallback = new EventEmitter<any>();


  isFillException: boolean = false;
  disableSubmit: boolean = true;
  candidatesToFill: any[] = [];
  candidatesToFillOrJoin: any[] = [];
  jobMatchesWhoseStatusCanBeSetArray: any[] = [];
  copyNote: any = "";
  isCorporateCompany: boolean = false;
  constructor(
    private companyService: CompanyService,
    private alertsAndNotificationsService: AlertAndNotificationsService,
    private jobMatchService: JobMatchService,
    private dateTimeUtilityService: DateTimeUtilityService,
    private fourDotFiveDateFormatPipe: FourDotFiveDateFormatPipe,
    private modalService: AngularModalService
  ) { }

  ngOnInit() {
    this.isFillException = false;
    this.disableSubmit = true;
    this.candidatesToFill = [];
    this.candidatesToFillOrJoin = [];
    this.jobMatchesWhoseStatusCanBeSetArray = [];
    this.isCorporateCompany = this.companyService.isCorporateCompany();
    this.candidatesToFillOrJoin = this.candidates;
    this._initializeDatePicker();
    if (this.job.currentStateName == 'Fill') {
      this._initializeFillCandidates();
    }
  }

  _initializeDatePicker() {
    $(document).ready(() => {
      if (this.job.currentStateName == 'Fill') {
        this._initializeFillCandidateDatePickers();
      } else {
        this._initializeJoinCandidateDatePickers();
      }
    });
  }

  _initializeFillCandidateDatePickers() {
    let currentDate = new Date();
    ($('#fillDate') as any).datepicker({
      format: "M d, yyyy",
      endDate: currentDate,
      weekStart: 1,
      autoclose: true
    });
    this.job.fillDateDisplayValue = this.fourDotFiveDateFormatPipe.transform(currentDate);
    // set current date as default value
    ($("#fillDate") as any).datepicker("setDate", currentDate);
    ($("#fillDate") as any).datepicker("update", this.fourDotFiveDateFormatPipe.transform(currentDate));
    ($('#fillDate') as any).datepicker().on('changeDate', (e) => {
      this.job.fillDateDisplayValue = this.fourDotFiveDateFormatPipe.transform(e.date);
      this.onFillDateChange();
    });

    ($('#expectedJoinDate') as any).datepicker({
      format: "M d, yyyy",
      startDate: currentDate,
      weekStart: 1,
      autoclose: true
    });

    ($('#expectedJoinDate') as any).datepicker().on('changeDate', (e) => {
      this.job.expectedJoinDateDisplayValue = this.fourDotFiveDateFormatPipe.transform(e.date);
      this.onExpectedJoinDateChange();
    });
  }

  _initializeJoinCandidateDatePickers() {
    let currentDate = new Date();
    ($('#joinDate') as any).datepicker({
      format: "M d, yyyy",
      startDate: currentDate,
      endDate: currentDate,
      weekStart: 1,
      autoclose: true
    });

    this.job.joinDateDisplayValue = this.fourDotFiveDateFormatPipe.transform(currentDate);
    // set current date as default value
    ($("#joinDate") as any).datepicker("setDate", currentDate);
    ($("#joinDate") as any).datepicker("update", this.fourDotFiveDateFormatPipe.transform(currentDate));
    ($('#joinDate') as any).datepicker().on('changeDate', (e) => {
      this.job.joinDateDisplayValue = this.fourDotFiveDateFormatPipe.transform(e.date);
      this.onJoinDateChange();
    });
  }

  _initializeFillCandidates() {
    this.candidates = [];
    this.job.candidate = undefined;
    this.onCandidateChange();
    this.isFillException = false;
    this.candidates = angular.copy(this.candidatesToFillOrJoin);
  }

  onCandidateSelectionExceptionChange() {
    this.candidates = [];
    this.job.candidate = undefined;
    this.onCandidateChange();
    if (this.isFillException) {
      this.candidates = angular.copy(this.candidatesInLastStep);
    } else {
      this.candidates = angular.copy(this.candidatesToFillOrJoin);
    }
  }

  onCandidateChange() {
    if (this.job.currentStateName == 'Fill') {
      this._setFillAndExpectedJoinDate();
      if (this.job.candidate) {
        this._setPendingItems();
        this.disableSubmit = this.job.candidate.canNotFill;
        if (this.job.candidate.filledJobNotBelongsToCurrentCorporate && this.isCorporateCompany) {
          let title = 'Cannot fill the candidate';
          let message = `This candidate cannot be filled at this time. Please connect with the Vendor to resolve this situation.`;
          this.alertsAndNotificationsService.showAlertWithCallBack(title, message, 'warning', () => {
            this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
          });
        }
        else if (this.job.candidate.canNotFill) {
          let title = 'Cannot fill the candidate';
          let message = `This candidate is currently filled in Req # <b>${this.job.candidate.filledInRequisitionNumber}</b> with Title <b>${this.job.candidate.filledInRequisitionTitle}</b> at <b>${this.job.candidate.clientOrBuOfFilledOrJoinedRequisition}</b>. Please perform 'Undo Fill' action on the candidate for that Requisition before performing the Fill action in this Requisition.`;
          this.alertsAndNotificationsService.showAlertWithCallBack(title, message, 'warning', () => {
            this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();
          });
        }
      } else {
        this.jobMatchesWhoseStatusCanBeSetArray = [];
      }
    } else {
      this._setJoinDate();
      if (this.job.candidate) {
        this._setPendingItems();
        this.disableSubmit = this.job.candidate.canNotJoin;
        if (this.job.candidate.joinedJobNotBelongsToCurrentCorporate && this.isCorporateCompany) {
          let title = 'Cannot join the candidate';
          let message = `This candidate cannot be joined at this time. Please connect with the Vendor to resolve this situation.`;
          this.alertsAndNotificationsService.showAlertWithCallBack(title, message, 'warning', () => {
            this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen();  
          });
        } else if (this.job.candidate.canNotJoin) {
          let title = 'Cannot join the candidate';
          let message = `This candidate is currently joined in Req # <b>${this.job.candidate.joinedInRequisitionNumber}</b> with Title <b>${this.job.candidate.joinedInRequisitionTitle}</b> at ${this.job.candidate.clientOrBuOfFilledOrJoinedRequisition} since <b>${this.fourDotFiveDateFormatPipe.transform(this.job.candidate.joinedDate)}</b>. Please perform a 'Job Left' action on the candidate for that Requisition before performing the Join action in this Requisition.`;
          this.alertsAndNotificationsService.showAlertWithCallBack(title, message, 'warning', () => {
            this.modalService.addModalOpenClassToBodyIfAnyModalIsOpen(); 
          });
        }
      }
    }
  }

  _setFillAndExpectedJoinDate() {
    this._setFillDate();
    if (!this._isExpectedJoinedDateNotSet()) {
      this._setExpectedJoinDate();
    } else {
      ($("#expectedJoinDate") as any).datepicker('setStartDate', this.job.candidateFillDate);
    }
  }

  _setPendingItems() {
    this.jobMatchesWhoseStatusCanBeSetArray = [];
    let candidate = angular.copy(this.job.candidate);
    let jobMatchIds = candidate.candidateOtherJobMatchDetail.map(jobMatch => jobMatch.jobMatchId);
    if (jobMatchIds.length > 0) {
      this.getPendingItems(jobMatchIds, (pendingItemsData) => {
        candidate.pendingItemsData = pendingItemsData;
        candidate.loadingPendingItemsFlag = false;
        candidate.candidateOtherJobMatchDetail.forEach(jobMatch => {
          let statusCanBeSetFlag = true;
          if (_.isUndefined(candidate.pendingItemsData.pendingAssessmentDetail[jobMatch.jobMatchId]) && _.isUndefined(candidate.pendingItemsData.pendingMeetingDetail[jobMatch.jobMatchId]) && _.isUndefined(candidate.pendingItemsData.filledOrJoinedCandidateDetail[jobMatch.jobMatchId])) {
            statusCanBeSetFlag = true;
            jobMatch.pendingItemsExistFlag = false;
            jobMatch.showAlert = false;
            jobMatch.message = "-";
          } else if (!_.isUndefined(candidate.pendingItemsData.filledOrJoinedCandidateDetail[jobMatch.jobMatchId])) {
            jobMatch.pendingItemsExistFlag = true;
            jobMatch.showAlert = true;
            jobMatch.message = "-";
            statusCanBeSetFlag = false;
          } else if (!_.isUndefined(candidate.pendingItemsData.pendingAssessmentDetail[jobMatch.jobMatchId])) {
            if (candidate.pendingItemsData.pendingAssessmentDetail[jobMatch.jobMatchId][0].inSentAssessmentState) {
              jobMatch.pendingItemsExistFlag = true;
              jobMatch.showAlert = true;
              if (candidate.pendingItemsData.pendingAssessmentDetail[jobMatch.jobMatchId][0].pendingAssessmentDTOs[0].type == 'Technical') {
                jobMatch.message = "<b>The Technical Assessment sent will be canceled and the concerned parties will be notified. This action cannot be reversed.</b>";
              } else if (candidate.pendingItemsData.pendingAssessmentDetail[jobMatch.jobMatchId][0].pendingAssessmentDTOs[0].type == 'Value') {
                jobMatch.message = "<b>The Value Assessment sent will be canceled and the concerned parties will be notified. This action cannot be reversed.</b>.";
              }
              statusCanBeSetFlag = true;
            } else if (candidate.pendingItemsData.pendingAssessmentDetail[jobMatch.jobMatchId][0].inprogressAny) {
              jobMatch.pendingItemsExistFlag = true;
              jobMatch.showAlert = true;
              if (candidate.pendingItemsData.pendingAssessmentDetail[jobMatch.jobMatchId][0].pendingAssessmentDTOs[0].type == 'Technical') {
                jobMatch.message = "<b>The Technical Assessment sent will be canceled and the concerned parties will be notified. This action cannot be reversed.</b>";
              } else if (candidate.pendingItemsData.pendingAssessmentDetail[jobMatch.jobMatchId][0].pendingAssessmentDTOs[0].type == 'Value') {
                jobMatch.message = "<b>The Technical Assessment sent will be canceled and the concerned parties will be notified. This action cannot be reversed.</b>";
              }
              statusCanBeSetFlag = false;
            } else {
              statusCanBeSetFlag = true;
              jobMatch.pendingItemsExistFlag = false;
              jobMatch.showAlert = false;
              jobMatch.message = "-";
            }
          } else if (!_.isUndefined(candidate.pendingItemsData.pendingMeetingDetail[jobMatch.jobMatchId])) {
            if (candidate.pendingItemsData.pendingMeetingDetail[jobMatch.jobMatchId][0].inprogressAny) {
              jobMatch.pendingItemsExistFlag = true;
              jobMatch.showAlert = true;
              if (candidate.pendingItemsData.pendingMeetingDetail[jobMatch.jobMatchId][0].pendingMeetings[0].type == 'INTERVIEW') {
                jobMatch.message = "<b>The Scheduled Interview(s) will be canceled and the concerned parties will be notified. This action cannot be reversed.</b>";
                jobMatch.meetingType = 'Interview';
                jobMatch.meetingsPopOverTitle = "'Interviews' that are in progress";
                jobMatch.meetingUserLabel = 'Interviewer';
              } else if (candidate.pendingItemsData.pendingMeetingDetail[jobMatch.jobMatchId][0].pendingMeetings[0].type == 'PHONE_SCREEN') {
                jobMatch.message = "<b>The Scheduled Phone Screen(s) will be canceled and the concerned parties will be notified. This action cannot be reversed.</b>";
                jobMatch.meetingType = 'Phone Screen';
                jobMatch.meetingsPopOverTitle = "'Phone Screens' that are in progress";
                jobMatch.meetingUserLabel = 'Phone Screener';
              }
              jobMatch.meetingInfoArray = this._getMeetingDetails(candidate.pendingItemsData.pendingMeetingDetail[jobMatch.jobMatchId][0].pendingMeetings);
              statusCanBeSetFlag = false;
            } else if (candidate.pendingItemsData.pendingMeetingDetail[jobMatch.jobMatchId][0].completedAny || candidate.pendingItemsData.pendingMeetingDetail[jobMatch.jobMatchId][0].completedAll || !candidate.pendingItemsData.pendingMeetingDetail[jobMatch.jobMatchId][0].inprogressAny) {
              jobMatch.pendingItemsExistFlag = true;
              jobMatch.showAlert = true;
              if (candidate.pendingItemsData.pendingMeetingDetail[jobMatch.jobMatchId][0].pendingMeetings[0].type == 'INTERVIEW') {
                jobMatch.message = "<b>The Scheduled Interview(s) will be canceled and the concerned parties will be notified. This action cannot be reversed.</b>";
                jobMatch.meetingType = 'Interview';
                jobMatch.meetingsPopOverTitle = "'Interviews' that will be 'Canceled'";
                jobMatch.meetingUserLabel = 'Interviewer';
              } else if (candidate.pendingItemsData.pendingMeetingDetail[jobMatch.jobMatchId][0].pendingMeetings[0].type == 'PHONE_SCREEN') {
                jobMatch.message = "<b>The Scheduled Phone Screen(s) will be canceled and the concerned parties will be notified. This action cannot be reversed.</b>";
                jobMatch.meetingType = 'Phone Screen';
                jobMatch.meetingsPopOverTitle = "'Phone Screens' that will be 'Canceled'";
                jobMatch.meetingUserLabel = 'Phone Screener';
              }
              jobMatch.meetingInfoArray = this._getMeetingDetails(candidate.pendingItemsData.pendingMeetingDetail[jobMatch.jobMatchId][0].pendingMeetings);
              statusCanBeSetFlag = true;
            }
          }
          this.jobMatchesWhoseStatusCanBeSetArray.push(jobMatch);
        })
      });
    }
  }

  getPendingItems(jobMatchIdsArray, successCallback) {
    this.jobMatchService.getPendingItems(jobMatchIdsArray, (data) => {
      if (successCallback) {
        successCallback(data);
      }
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  _getMeetingDetails(meetingsArray) {
    let modifiedMeetingsArray = [];
    angular.forEach(meetingsArray, (meeting, key) => {
      meeting.startDateTime = new Date(meeting.startTime);
      meeting.endDateTime = new Date(meeting.endTime);
      switch (meeting.status) {
        case 'SCHEDULED':
          meeting.statusClass = 'fa fa-calendar set-job-match-status-meeting-icon-scheduled';
          meeting.statusLabel = 'Scheduled';
          break;
        case 'IN_PROGRESS':
          meeting.statusClass = 'fa fa-hourglass-half set-job-match-status-meeting-icon-in-progress';
          meeting.statusLabel = 'In Progress';
          break;
        case 'COMPLETED':
          meeting.statusClass = 'fa fa-check set-job-match-status-meeting-icon-completed';
          meeting.statusLabel = 'Completed';
          break;
        case 'OVERDUE':
          meeting.statusClass = 'fas fa-clock set-job-match-status-meeting-icon-overdue';
          meeting.statusLabel = 'Overdue';
          break;
        case 'CANCELLED':
          meeting.statusClass = 'fa fa-ban set-job-match-status-meeting-icon-cancelled';
          meeting.statusLabel = 'Canceled';
          break;
        default:
          // set defaults
          meeting.statusClass = 'fa fa-question set-job-match-status-meeting-icon-in-progress';
          meeting.statusLabel = 'Status Unknown';
      }
      meeting.userName = meeting.participants[0].name;
      modifiedMeetingsArray.push(meeting);
    });
    return modifiedMeetingsArray;
  }

  _setFillDate() {
    if (this.job.candidate !== undefined) {
      let currentDate = new Date();
      let jobMatchDate = moment(this.job.candidate.jobMatchDate).toDate();
      console.log('job match date: ', jobMatchDate);
      console.log('job match date display: ', this.job.fillDateDisplayValue);
      console.log('type Of ', typeof this.job.fillDateDisplayValue);
      // $("#fillDate").datepicker('setStartDate', jobMatchDate);
      this.job.candidateFillDate = moment(this.job.fillDateDisplayValue).startOf("day").toDate();
      if (jobMatchDate > this.job.candidateFillDate) {
        // this.job.candidateFillDate = currentDate;
        ($("#fillDate") as any).datepicker("setDate", this.job.candidateFillDate);
        ($("#fillDate") as any).datepicker("update", this.fourDotFiveDateFormatPipe.transform(this.job.candidateFillDate));
      }
    }
  }

  _setExpectedJoinDate() {
    ($("#expectedJoinDate") as any).datepicker('setStartDate', this.job.candidateFillDate);
    this.job.candidateExpectedJoinDate = moment(this.job.expectedJoinDateDisplayValue).startOf("day").toDate();
    if (this.job.candidateExpectedJoinDate < this.job.candidateFillDate) {
      this.job.candidateExpectedJoinDate = this.job.candidateFillDate;
      ($("#expectedJoinDate") as any).datepicker("setDate", this.job.candidateExpectedJoinDate);
      ($("#expectedJoinDate") as any).datepicker("update", this.fourDotFiveDateFormatPipe.transform(this.job.candidateExpectedJoinDate));
    }
  }

  _setJoinDate() {
    if (this.job.candidate !== undefined) {
      let currentDate = new Date();
      let fillDate = moment(this.job.candidate.filledDate).toDate();
      ($("#joinDate") as any).datepicker('setStartDate', fillDate);
      this.job.candidateJoinDate = moment(this.job.joinDateDisplayValue).startOf("day").toDate();
      if (fillDate > this.job.candidateJoinDate) {
        this.job.candidateJoinDate = currentDate;
        ($("#joinDate") as any).datepicker("setDate", this.job.candidateJoinDate);
        ($("#joinDate") as any).datepicker("update", this.fourDotFiveDateFormatPipe.transform(this.job.candidateJoinDate));
      }
    }

  }

  onFillDateChange() {
    this._setFillAndExpectedJoinDate();
  }

  onJoinDateChange() {
    this._setJoinDate();
    this._setFillDate();
  }

  onExpectedJoinDateChange() {
    this._setExpectedJoinDate();
  }

  save() {
    if (this.fillOrjoinCandidateForm.valid) {
      this._parseDatesBeforeSave();
      if (this.saveCallback) {
        this.saveCallback.emit();
      }
    } else {
      this.fillOrjoinCandidateForm.onSubmit(undefined);
    }
  }

  cancel() {
    if (this.cancelCallback) {
      this.cancelCallback.emit();
    }
  }

  _parseDatesBeforeSave() {
    if (this.job.currentStateName == 'Fill') {
      this.job.candidateFillDate = this.dateTimeUtilityService.getDateTimeInAPIFormat(new Date(this.job.candidateFillDate));
      this.job.candidateExpectedJoinDate = this.dateTimeUtilityService.getDateTimeInAPIFormat(new Date(this.job.candidateExpectedJoinDate));
      if (this._isExpectedJoinedDateNotSet()) {
        this.job.candidateExpectedJoinDate = null;
      }
    } else {
      this.job.candidateJoinDate = this.dateTimeUtilityService.getDateTimeInAPIFormat(new Date(this.job.candidateJoinDate));
    }
  }

  _isExpectedJoinedDateNotSet() {
    return this.job.expectedJoinDateDisplayValue == undefined || this.job.expectedJoinDateDisplayValue.trim() == "";
  }


  onExternalNoteChange(event) {
    this.job.externalNote = event.externalNote;
  }

  onCopyNoteChange(event) {
    this.copyNote = event.copyNote;
  }

  receiveFormalizedComment(event) {
    this.job.note = event;
    this.onInternalNoteChanged();
  }

  onVoiceTranscript(transcript) {
    if (this.job.note) {
      this.job.note += ' ' + transcript;
    } else {
      this.job.note = transcript;
    }
    this.onInternalNoteChanged();
  }

  onInternalNoteChanged() {
    console.log(this.job.note);
  }

}
